<template>
  <v-container fluid class="team-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Team</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">New Team</p>
                        <v-text-field
                          class="mb-4"
                          v-model="team.teamcode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Team Code"
                          persistent-hint
                          single-line hint="Enter the team code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="team.teamname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Team Name"
                          persistent-hint
                          single-line hint="Enter the team name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="team.teamtype"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the team type">
                        </v-select>
                          <v-switch
                            v-model="team.teamstatus"
                            color="primary"
                            v-bind:label="team.teamstatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/team/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertTeam()">
                            Save
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      team: {teamstatus: 'Active'},
      items: ['Team', 'Other Team'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Team', ['insertTeamRequest', 'getTeamsRequest']),
    checkError(){
      if(!this.team.teamcode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.team.teamname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.team.teamtype){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    async insertTeam() {
      if(!this.checkError()) return;
      await this.insertTeamRequest(this.team);
      this.getTeamsRequest();
      router.push('/team/list');
    },
  },
  computed: {
    ...mapState('Team', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
